import { KiteIcon } from '@kite/react-kite';
import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import { sortMenuItems } from '../../../shared/sortMenuItems';
import './LoginBar.scss';
import {
    EventName,
    UserInteractionType,
    TrackedParentNode,
    UserInteractionEvent,
} from '../../../models/GTMEventTypes';
import { onClickEventTracker } from '../../../shared/analytics/callAnalytics';
import resolvePath from '../../../shared/resolvePath';

export const LoginBar = () => {
    const menuData = useStaticQuery(graphql`
        query {
            allMenuItems(filter: { menu_name: { eq: "login-bar" } }) {
                nodes {
                    title
                    id
                    url
                    weight
                }
            }
        }
    `);

    // Populates meta data for the user interaction event based on menu item properties
    const createEvent = (
        item: any
    ): Record<`eventAnalytics`, UserInteractionEvent> => {
        return {
            eventAnalytics: {
                event: EventName.USER_INTERACTION,
                event_data: {
                    type: UserInteractionType.LINK_CLICK,
                    component_name: item.title,
                    component_type: item.url.startsWith(`/`)
                        ? `Internal Link`
                        : `External Link`,
                    parent_name: undefined,
                    parent_type: `Login_Bar` as TrackedParentNode,
                    current_path: resolvePath(),
                    next_path: item.url,
                },
            },
        };
    };

    // Hard codes phone number data to pass to the createEvent function
    const { eventAnalytics: phoneNumEventAnalytics } = createEvent({
        title: `1-844-To-Reach`,
        url: `tel:+1-844-To-Reach`,
    });

    const menuItems = menuData.allMenuItems.nodes.sort(sortMenuItems);

    return (
        <nav className="login-bar dark">
            <div className="kite-container">
                <div className="phone">
                    <KiteIcon icon="ki-phone-f" />
                    <a
                        href="tel:+1-844-To-Reach"
                        onClick={(e) =>
                            onClickEventTracker(e, phoneNumEventAnalytics)
                        }
                    >
                        1-844-To-Reach
                    </a>
                </div>
                <ul>
                    {menuItems.map((item) => {
                        const { eventAnalytics } = createEvent(item);
                        return (
                            <li key={item.id}>
                                <a
                                    href={item.url}
                                    onClick={(e) =>
                                        onClickEventTracker(e, eventAnalytics)
                                    }
                                >
                                    {item.title}
                                </a>
                            </li>
                        );
                    })}
                </ul>
            </div>
        </nav>
    );
};
